const fieldLabels: Record<string, string> = {
  name: "onboarding-business-name",
  businessRegNo: "business-reg",
  address: "address",
  zipcode: "postal-code",
  city: "city",
  internalAppType: "onboarding-setup-account-type",
};

function record(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" ? value as Record<string, unknown> : {};
}

/** Show actionable categories and known field labels, never raw provider errors. */
export function getOrganizationSetupError(error: unknown): { messageKey: string; fieldKeys?: string[] } {
  const data = record(error);
  const details = record(data.details);
  const issues = Array.isArray(data.issues) ? data.issues : [];
  const fields = Array.isArray(details.fields) ? details.fields : issues.map((issue) => {
    const path = record(issue).path;
    return Array.isArray(path) ? path[0] : undefined;
  });
  const labels = [...new Set(fields.filter((field): field is string => typeof field === "string" && Object.prototype.hasOwnProperty.call(fieldLabels, field)).map((field) => fieldLabels[field]))];
  if (labels.length) return { messageKey: "onboarding-setup-invalid-fields", fieldKeys: labels };
  const code = typeof data.code === "string" ? data.code : "";
  const message = typeof data.message === "string" ? data.message : typeof error === "string" ? error : "";
  if (/network|offline|unavailable/.test(code) || message.includes("online-user-required")) {
    return { messageKey: "onboarding-setup-connection-error" };
  }
  if (/unauthenticated/.test(code) || message.includes("authenticated-user-required")) {
    return { messageKey: "onboarding-setup-sign-in-required" };
  }
  if (/setup-in-progress|setup-lease-changed/.test(message)) return { messageKey: "onboarding-setup-in-progress" };
  if (/membership-not-ready|org-does-not-exist|organization-initialization-not-ready/.test(message)) {
    return { messageKey: "onboarding-setup-organization-not-ready" };
  }
  if (message.includes("subscription-not-ready")) return { messageKey: "onboarding-setup-subscription-not-ready" };
  if (code === "functions/invalid-argument" || message.includes("invalid-organization-data")) {
    return { messageKey: "onboarding-setup-invalid-details" };
  }
  return { messageKey: "onboarding-setup-failed" };
}
